import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../ConfigService';


import { getFirebaseBackend } from '../../authUtils';

import { User } from '../models/auth.models';


@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    user: User;

    constructor(private http: HttpClient) {
    }

    /**
     * Returns the current user
     */
    public currentUser(): User {
        return getFirebaseBackend().getAuthenticatedUser();
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string) {
        return getFirebaseBackend().loginUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(email: string, password: string) {
        return getFirebaseBackend().registerUser(email, password).then((response: any) => {
            const user = response;
            return user;
        });
    }

    /**
     * Reset password
     * @param email email
     */
    resetPassword(usuario: string,compania:string) {
      return this.http.post<boolean>(ConfigService.settings.apiUrl+"Erusuarios/recuperar?usuario="+usuario+"&compania="+compania,"").subscribe(data=>{


      });

/*         return getFirebaseBackend().forgetPassword(email).then((response: any) => {
            const message = response.data;
            return message;
        }); */
    }

    /**
     * Logout the user
     */
    logout() {
        // logout the user
        getFirebaseBackend().logout();
    }
}

